import React, { Component } from 'react';
import '../../../Assets/EnsembleStyles/EnsHome.css';
import NavigationBar from '../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */
import TitleBar from '../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';                                              /* Titile  Bar */
import Footer from '../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';

// SubRouting
import DashboardSubRouting from '../Common/Layouts/SubRouting/DashboardSubRouting';



export default class Dashboard extends Component {

    showSettings(event) {
        event.preventDefault();
    }
    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300
        }
        this.toggleSide = this.toggleSide.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
    }

    toggleSide(action) {
        switch (action) {
            case "open": this.setState({ sideSize: 200, drag: 200 });
                break;
            case "close": this.setState({ sideSize: 1, drag: 1 });
                break;
            default : break;
        }
    }

    handleDrag(width) {
        this.setState({ drag: width + 10 });
    }


    render() {
        return (
            <div className="Ensemble">

            {/* Navigation Bar */}
                <NavigationBar />  

            {/* Title bar displays the title of the page */}
                <TitleBar  parentToChildData={"Dashboard"} istabView={false}/> 

                 <div className="Ensemble_Content margin_top">

                    <DashboardSubRouting  match={this.props.match}  /> 

                    </div> 

                {/* Side Bar */}
                {/* <SplitPane split="vertical" size={this.state.sideSize} onChange={this.handleDrag} >
                    <div className="sidePane">
                        <Sidebar />
                        <span className={"closebutton " + (this.state.drag <= 1 ? "hidden" : "")} onClick={() => this.toggleSide("close")} style={{ left: this.state.drag + 'px' }}>
                            <FaDoubleLeft className="icon" />
                        </span>
                        <span className={"openbutton " + (this.state.drag > 1 ? "hidden" : "")} onClick={() => this.toggleSide("open")} style={{ left: this.state.drag + 'px' }}>
                            <FaDoubleRight className="icon" />
                        </span>
                    </div>
                    <div className="">

                    <DashboardSubRouting  match={this.props.match}  /> 

                    </div>
                </SplitPane> */}

                {/* Footer */}
                <Footer />
            </div>
        );
    }
}
